<div class="ep_card">
    <div class="ep_card-header ep_card-header-icon ep_card-header-warning" >
      <div class="ep_card-icon"><i class="material-icons">sim_card_download</i></div>
      <p class="ep_card-category">Download Schede Novità </p> 
    </div>
    <div class="ep_card-footer" *ngIf="!loader.pdf">
          <button mat-raised-button class="download-option" (click)="downloadSchede()" > 
            <img   src="{{getIcon('pdf') }}" class="image"   />    &nbsp;Unico pdf delle novità 
          </button>
    </div>
    <div class="ep_card-footer" *ngIf="loader.pdf">
     <div align="center">Download in corso , ti preghiamo di aspettare, potrebbe volerci qualche minuto.</div> 
      <mat-spinner  [diameter]="35" class="mx-auto"   ></mat-spinner>
    </div>
  </div>
